import { render } from "./SalesTableCard.vue?vue&type=template&id=1746f8b9"
import script from "./SalesTableCard.vue?vue&type=script&lang=js"
export * from "./SalesTableCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__